import { useEffect, useState } from "react";

import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";
import { BuyTicketsTextButton } from "../../common/buttons/BuyTicketsButton";
import {
  convertTo24HrTime,
  convertToShortDate,
} from "../../../utils/helpers/dateAndTime";

const FixtureCard = ({ fixture, ticketUrl }) => {
  const [fixtureTime, setFixtureTime] = useState("");
  const [fixtureDate, setFixtureDate] = useState("");

  useEffect(() => {
    setFixtureTime(convertTo24HrTime(fixture.date_and_time));
    setFixtureDate(convertToShortDate(fixture.date_and_time));
  }, [fixture.date_and_time]);

  return (
    <>
      <div className="sm:px-10 mx-2 sm:mx-4 lg:mx-auto lg:max-w-5xl xl:max-w-6xl 2xl:max-w-[1220px] rounded-md border-2 border-red-600 dark:border-green-800 space-y-4 py-4 sm:py-6">
        <div className="flex flex-col justify-center items-center text-center">
          <div className="text-xs text-gray-400">{fixture.competition}</div>
          <div className="text-xs text-gray-400">
            {fixture.week_or_round_number}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center sm:flex-row sm:justify-between sm:items-center">
          <div className="flex justify-center items-center space-x-4">
            <div className="hidden sm:block divide-y-2 divide-red-600">
              <Image
                src={fixture.competition_logo}
                alt="Competition Logo"
                width="35px"
                height="35px"
                quality={100}
                priority
              />
            </div>
            <span
              className="h-14 w-px ml-4 mr-4 bg-red-600 dark:bg-green-800 hidden sm:block"
              aria-hidden="true"
            ></span>
            <div>
              <Image
                src={
                  fixture.home_team === "Kotoko" ||
                  fixture.home_team === "Asante Kotoko"
                    ? fixture.away_team_logo
                    : fixture.home_team_logo
                }
                alt="Team Logo"
                width="96px"
                height="96px"
                quality={100}
                priority
                placeholder="blur"
                blurDataURL={blurDataURL}
              />
            </div>
            <div className="flex flex-col justify-center items-start">
              <div className="mb-4">
                <p className="text-base font-bold w-40 sm:w-64 whitespace-nowrap truncate">
                  {fixture.home_team === "Kotoko" ||
                  fixture.home_team === "Asante Kotoko"
                    ? fixture.away_team
                    : fixture.home_team}
                </p>
                <p className="text-xs text-gray-400 truncate w-56">
                  {fixture.home_team === "Kotoko" ||
                  fixture.home_team === "Asante Kotoko"
                    ? `${fixture.venue} (H)`
                    : `${fixture.venue} (A)`}
                </p>
              </div>

              <div className="text-xs">
                <span className="font-bold">{`${fixtureTime}, `}</span>
                <span className="font-normal text-gray-400">{fixtureDate}</span>
              </div>
            </div>
          </div>

          <div>
            {fixture.home_team === "Kotoko" ||
            fixture.home_team === "Asante Kotoko" ? (
              <BuyTicketsTextButton ticketWebsiteUrl={ticketUrl} />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FixtureCard;
